import { FixedSizeList as List } from 'react-window';
import { getSignedUrl } from 'helpers/prechecks';
import { Session } from 'globals/interfaces';
import { formatDate } from 'helpers/date';
import { gutterSize, cameraGrabListHeight, listItemSize } from 'common/components/constant';
import { useMemo, useState } from 'react';
import EnlargeView from './EnlargeView';
import useSessionSasToken from 'hooks/useSessionSasToken';
import { useAppSelector } from 'app/hooks';

interface Props {
  session: Session;
  sessionId: string;
}

const CameraAndScreenGrabsList = ({ sessionId, session }: Props) => {
  const token = useAppSelector((state) => state.session?.token);
  const [showPreview, setShowPreview] = useState<boolean>(false);
  const [selectedGrab, setSelectedGrab] = useState<any>(null);
  const fallbackToken =
    session?.session_id && token?.[session.session_id]
      ? token[session.session_id].value
      : undefined;
  const signedToken =
    useSessionSasToken(sessionId, session?.session_uuid) || fallbackToken;
  const files = useMemo(() => {
    if (!session?.session_files) return [];
    return Object.values(session.session_files).slice().reverse();
  }, [session?.session_files]);

  const calculateWeight = () => {
    return (window.innerWidth * 58) / 100 + 2 * gutterSize;
  };

  const isrenderList = Boolean(signedToken) && files.length > 0;

  const handleGrabClick = (file) => {
    const grab = {
      img_src: getSignedUrl(session.session_uuid, file.path, signedToken),
      timestamp: formatDate(file.timestamp),
    };
    setSelectedGrab(grab);
    setShowPreview(true);
  };
  return (
    isrenderList && (
      <>
        <List
          itemData={files}
          height={cameraGrabListHeight}
          itemCount={files.length}
          itemSize={listItemSize + gutterSize}
          layout="horizontal"
          width={calculateWeight()}
        >
          {({ data, index, style }) => {
            if (!data[index]) return null;
            const file = data[index];
            return (
              <div
                key={file.timestamp}
                style={{
                  ...style,
                  marginLeft: gutterSize,
                  marginRight: gutterSize,
                  borderBottom: '3px solid #CBD5E1',
                }}
              >
                <div
                  className="flex flex-col items-center align-middle"
                  onClick={() => handleGrabClick(file)}
                >
                  <div className="screen-grab-container">
                    {signedToken && (
                      <img
                        className="m-auto"
                        src={getSignedUrl(session.session_uuid, file.path, signedToken)}
                        alt="screen or camera grab"
                      />
                    )}
                  </div>
                  <div className="mt-2">{formatDate(file.timestamp)}</div>
                </div>
              </div>
            );
          }}
        </List>
        <EnlargeView
          selectedGrab={selectedGrab}
          showPreview={showPreview}
          setShowPreview={setShowPreview}
        />
      </>
    )
  );
};

export default CameraAndScreenGrabsList;
